import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);


/**
 * Open PDFs in new window
 */
function linksCustomization(){
	var pdfLinks = document.querySelectorAll('a[href$=".pdf"]')

	pdfLinks.forEach(pdf => {
		pdf.setAttribute('target', '_blank');
	});
}

/**
 * Adds smooth scrolling to anchor links
 * 
 * Adds data-scroll-to attribute to anchor links without it.
 */
function scrollTo(){
	// Function to handle smooth scrolling for anchor links
	function smoothScroll(targetSelector, offset) {
		const element = document.querySelector(targetSelector);

		if (element) {
			const topPosition = element.getBoundingClientRect().top + window.scrollY - offset;

			window.scrollTo({
				top: topPosition,
				behavior: 'smooth'
			});
		}
	}

	// Detect all anchor links on the page without data-scroll-to attribute
	const scrollToLinks = document.querySelectorAll('a[href^="#"]:not([data-scroll]):not([class^="magnific-"]):not([data-fancybox])')
	scrollToLinks.forEach(link => {
		// Skip those with only the hashtag
		if (link.getAttribute('href').length > 1) {
			link.setAttribute('data-scroll', 'scroll-to');
		}
	});

	
	// Event listener for anchor links
	let anchorLinks = document.querySelectorAll( '[data-scroll="scroll-to"]' )

	anchorLinks.forEach(element => {
		element.addEventListener('click', function(event) {
			event.preventDefault();

			const target = event.currentTarget;

			let offset = 50; // Default offset
			if (target.getAttribute('data-scroll-space')) {
				offset = parseInt(target.getAttribute('data-scroll-space'), 10);
			}

			smoothScroll(target.getAttribute('href'), offset);
		});
	});
}

/**
 * Adds a class to tablepress tables to make them responsive.
 */
function responsiveTables(){
	if ( document.querySelectorAll('.prose table').length > 0 ) {
		const tables = document.querySelectorAll('.prose table');

		var wrap = function (toWrap, wrapper) {
			wrapper = wrapper || document.createElement('div');
			wrapper.classList.add('responsive-table');
			
			// Insert the wrapper before the toWrap element
			toWrap.parentNode.insertBefore(wrapper, toWrap);
			
			return wrapper.appendChild(toWrap);
		};

		[...tables].forEach((table) => {
			wrap(table);
		});
	}
}

function homepageHoverEffect(){
	const upperAndLowerSchools = document.querySelectorAll('[data-target="upper-and-lower-school"]');
	if( window.innerWidth > 991 && upperAndLowerSchools.length > 0){
		upperAndLowerSchools.forEach(school => {
			const schoolPages = school.querySelectorAll('[data-hover^="school-page"]');
			//console.log(schoolPages);
			const allImages = school.querySelectorAll('.school-page-images');
			schoolPages.forEach(schoolPage => {
				var relatedImage = school.querySelector('.'+schoolPage.dataset.hover);
				schoolPage.addEventListener('mouseenter', function(event) {
					//console.log('mouseenter');
					// reset
					allImages.forEach(image => {
						image.style.opacity = '0';

					});
					schoolPages.forEach(page => {
						page.classList.remove('active');
					});
					relatedImage.style.opacity = '1';
					schoolPage.classList.add('active');
				});
			})
		});
	}
}

function parallaxEffect(){
	const parallaxElements = document.querySelectorAll('[data-parallax]');

	if ( parallaxElements.length > 0 ){
		parallaxElements.forEach(element => {
			gsap.fromTo(element, {  y: '180px' }, { y: '-180px', ease: 'none',
				scrollTrigger: {
					trigger: element,
					start: 'top bottom',
					end: 'bottom top',
					scrub: 0.2
				}
			});
		});
	}
}

function followingCursor (){
	const followingCursors = document.querySelectorAll( '[data-name="following-cursor"]' );

	if ( followingCursors.length > 0 ) {
		if ( window.innerWidth < 992 ) return;

		followingCursors.forEach( ( cursor ) => {
			const follingArea = cursor.closest('[data-name="following-cursor-area"]');

			if ( cursor && follingArea ) {
				follingArea.addEventListener("mouseenter", function() {
					cursor.style.opacity = "1";
					cursor.style.display = "flex";
					gsap.set(cursor, {xPercent: -50, yPercent: -50});
				});

				follingArea.addEventListener("mouseleave", function() {
					cursor.style.opacity = "0";
					cursor.style.display = "none";
				});

				// Following animation.
				let xTo = gsap.quickTo(cursor, "x", {duration: 0.5, ease: "power3"}),
					yTo = gsap.quickTo(cursor, "y", {duration: 0.5, ease: "power3"});

				window.addEventListener("mousemove", e => {
					xTo(e.clientX);
					yTo(e.clientY);
				});
			} else {
				console.warn("Element not found.");
			}
		});
	}
}




export { linksCustomization, scrollTo, responsiveTables, homepageHoverEffect, parallaxEffect, followingCursor }